import React, { useState } from "react";
import "./input.scss";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { CiFileOn } from "react-icons/ci";

export default function Input({
    type = "text",
    label,
    placeholder,
    multipleFiles = false,
    disabled = false,
    required = false,
    onChange,
    value,
    onBlur,
    onKeyDown,
    ...props
}) {
    const [showPassword, setShowPassword] = useState(false);

    const inputType = type === "password" && showPassword ? "text" : type;

    const handleChange = (e) => {
        if (type === "file") {
            if (onChange) onChange(e);
        } else {
            let newValue = e.target.value;
            if (type === "number") {
                newValue = newValue === "" ? "" : parseFloat(newValue);
            }
            if (onChange) {
                onChange({
                    target: {
                        name: props.name,
                        value: newValue,
                    },
                });
            }
        }
    };

    return (
        <div
            className={`input input--${type} ${
                disabled ? "input--disabled" : ""
            }`}
        >
            {label && (
                <label className="input__label">
                    {label}
                    {required && <span className="input__required">*</span>}
                </label>
            )}

            <div className="input__wrapper">
                <div className="input__text">
                    {type === "file" && (
                        <>
                            <CiFileOn />
                            <span className="input__text-placeholder">
                                Selecciona un archivo
                            </span>
                        </>
                    )}
                </div>
                <input
                    className={`input__element input__element--${type}`}
                    type={inputType}
                    autoComplete="nope"
                    placeholder={placeholder}
                    multiple={type === "file" && multipleFiles}
                    disabled={disabled}
                    value={value}
                    onChange={handleChange}
                    onBlur={onBlur}
                    onKeyDown={onKeyDown}
                    {...props}
                />
                {type === "password" && !disabled && (
                    <span
                        className="input__icon"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                    </span>
                )}
            </div>
        </div>
    );
}
